import PropTypes from 'prop-types';

const travelPassProductShape = PropTypes.shape({
  travelDate: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  name: PropTypes.string,
  code: PropTypes.string,
  price: PropTypes.number,
  currency: PropTypes.string,
  itemRef: PropTypes.string,
  type: PropTypes.string,
  passenger: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  cancelled: PropTypes.bool,
  provisional: PropTypes.bool
});

export default travelPassProductShape;
